module.exports = __webpack_public_path__ + "img/promotion-list-empty.7d3d8d5.webp";